import { CalculateTalentAgeResult } from '../types';

export const calculateTalentAge = (dob: Date): CalculateTalentAgeResult => {
  if (dob) {
    const diffMs = Date.now() - new Date(dob).getTime();
    const ageDt = new Date(diffMs);

    const ageYears = Math.abs(ageDt.getUTCFullYear() - 1970);
    const ageMonths = Math.abs(ageDt.getUTCMonth());

    return {
      years: String(ageYears),
      months: String(ageMonths),
    };
  }
  return {
    years: '',
    months: '',
  };
};

export default calculateTalentAge;
